import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  confirmActionModal:{
    open: false,
    title: 'Xác nhận thao tác',
    description: '',
    submit: undefined
  }
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    openConfirmActionModal: (state, action) => {
      state.confirmActionModal = action.payload
    },
    closeConfirmActionModal: (state, action) => {
      state.confirmActionModal.open = false
    }
  },
})

// Action creators are generated for each case reducer function
export const {openConfirmActionModal, closeConfirmActionModal } = appSlice.actions

export default appSlice.reducer